package game.controller

import game.CgaColor
import game.Game
import view.Terminal

class Label(text: String, col: Int, row: Int, width: Int, height: Int) :
    Component(text, col, row, width, height) {

    override fun render(game: Game, terminal: Terminal) {
        terminal.drawString(col, row, text, CgaColor.LIGHT_GRAY, CgaColor.BLACK)
    }
}